module.exports = __webpack_public_path__ + "static/media/group_plus.3eb9f423.svg";